export const CHECKOUT_URL = "https://prenatal-training-pro.impultienda.ar/checkout";
export const OFFER_HASH = "#offer";
export const SUPPORT_EMAIL = "compradigitalyaa@gmail.com";
export const PRICE = "$26.90";
export const PRICE_VALUE = 26.9;
export const VOLUMES_REGULAR_PRICE = 39.9;
